import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart} from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import * as OktaSignIn from '@okta/okta-signin-widget';
import { environment } from  '../../../environments/environment'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']

})

export class LoginComponent implements OnInit {
  authService;
  isAuthenticated;
  widget = new OktaSignIn({
    el: '#okta-signin-container',
    logo: '../../../assets/icon/freepoint_logo.svg',
    i18n: {
      //Overrides default text when using English. Override other languages by adding additional sections.
      'en': {
        'primaryauth.title': 'Broker Hub Login',   // Changes the sign in text
        'primaryauth.submit': 'Login',  // Changes the sign in button
        // More e.g. [primaryauth.username.placeholder,  primaryauth.password.placeholder, needhelp, etc.].
        // Full list here: https://github.com/okta/okta-signin-widget/blob/master/packages/@okta/i18n/dist/properties/login.properties
      }

    },
    baseUrl: environment.baseUrl,
    authParams: {
      pkce: false
    },
    clientId: environment.clientId,
    redirectUri: environment.redirectUri,
    // features: {
    //   registration: true
    // }
    customButtons: [{
      title: 'Registration',
      className: 'registration-btn',
      click: () => {
        window.location.href = 'https://www.freepointsolutions.com/apply-now/';
      }
    }]
  });

  constructor(oktaAuth: OktaAuthService, router: Router) {

    this.authService = oktaAuth;
    this.authService.$authenticationState.subscribe(
       (isAuthenticated: boolean)  => {
        this.isAuthenticated = isAuthenticated;

      }
    );
    // Show the widget when prompted, otherwise remove it from the DOM.
    router.events.forEach(event => {
      if (event instanceof NavigationStart) {
        switch(event.url) {
          case '/login':
            break;
          case '/preferred-pricing':
            break;
          default:
            this.widget.remove();
            break;
        }
      }
    });
  }

    ngOnInit() {
      this.widget.showSignInAndRedirect().catch(err => {
        throw(err);
      });

      this.authService.isAuthenticated().then((result) => {

      })
    }
}
